import { render, staticRenderFns } from "./RepairRequest.vue?vue&type=template&id=941d34ae&scoped=true&"
import script from "./RepairRequest.vue?vue&type=script&lang=ts&"
export * from "./RepairRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941d34ae",
  null
  
)

export default component.exports